export default __webpack_public_path__ + "static/media/businessInformationIcon.3c4dbedd.svg";